<template>
  <div class="field role">
    <span v-if="label"
          class="label text-right"
          :class="labelClass"
    >
      {{ label }}
    </span>

    <div class="value v-align"
         :class="valueClass"
    >
      <b-badge v-for="value of getValue"
               :key="value.id"
               :class="value.class | lowercase"
      >
        {{ value.text }}
      </b-badge>
    </div>
  </div>
</template>

<script>
import bBadge from 'bootstrap-vue/es/components/badge/badge'
import formatter from '@/components/global/mixins/formatterMethods'

export default {
  components: {
    bBadge
  },

  mixins: [formatter],

  props: {
    value: {
      type: [String, Array]
    },
    label: String,
    width: String
  },

  computed: {
    valueClass () {
      if (this.label) {
        return 'col-8'
      }
    },

    labelClass () {
      if (this.width === 'large') {
        return 'col-2'
      } else {
        return 'col-4'
      }
    },

    getValue () {
      let ret = []

      if (typeof this.value === 'string') {
        ret.push({
          class: this.value,
          text: this.translateConst(this.value)
        })
      } else {
        for (let value of this.value) {
          ret.push({
            class: value,
            text: this.translateConst(value)
          })
        }
      }

      return ret
    }
  }
}
</script>
